import { Text, View } from '@react-pdf/renderer';

import { styles } from '../style';

const CashOffer = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Cash Offer</Text>

      <Text style={styles.text}>
        Buyer may elect to make this Agreement contingent upon obtaining
        mortgage financing. Regardless of any contingency in this Agreement, if
        Buyer chooses to obtain mortgage financing, the following terms apply:
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. <Text style={styles.ClauseText}>Buyer</Text> will be in default of
          this Agreement if Buyer furnishes false information regarding
          financial/employment status, fails to cooperate in good faith with
          loan processing (including timely appraisal), fails to lock interest
          rate(s) as required, or otherwise causes lender rejection.
        </Text>

        <Text style={styles.listItem}>
          2. <Text style={styles.ClauseText}>Within 7 days</Text> from the{' '}
          <Text style={styles.ClauseText}>Execution Date</Text>, Buyer will make
          a completed mortgage application (including credit reports without
          delay) to the mortgage lender(s), if any, otherwise to a responsible
          lender of Buyer’s choice. Brokers may communicate with lender(s) to
          assist and obtain status updates.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.ClauseText}>Seller</Text> will provide access
          as required by lender(s) to surveyors, municipal officials,
          appraisers, inspectors, and insurers’ representatives.
        </Text>

        <Text style={styles.listItem}>
          4. If lender(s) give Buyer the right to lock interest rate(s) at or
          below desired maximums, Buyer will do so at least{' '}
          <Text style={styles.ClauseText}>10 days before Settlement Date</Text>.
        </Text>

        <Text style={styles.listItem}>
          5. If lender(s) or required insurer demands repairs, Buyer will
          deliver requirements to Seller. Within{' '}
          <Text style={styles.InfoText}>7 days</Text> of receipt, Seller will
          notify Buyer whether Seller will make the repairs at Seller’s expense.
        </Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            1. If Seller makes the required repairs to lender/insurer
            satisfaction, Buyer accepts the Property and agrees to the Release
            clause.
          </Text>
          <Text style={styles.listItem}>
            2. If Seller will not make the required repairs, or fails to respond
            in time, within 7 days Buyer will notify Seller of Buyer’s choice
            to:
          </Text>
          <View style={styles.list}>
            <Text style={styles.listItem}>
              1) Make the repairs/improvements at Buyer’s expense, with
              reasonable access granted by Seller (Seller may require a
              pre-settlement possession agreement), OR
            </Text>
            <Text style={styles.listItem}>
              2) Terminate this Agreement by written notice to Seller, with all
              deposit monies returned to Buyer according to this Agreement.
            </Text>
            <Text style={styles.listItem}>
              3) If Buyer fails to respond/terminate within the stated time,
              Buyer accepts the Property and will make the required
              repairs/improvements at Buyer’s expense and agrees to the Release
              clause.
            </Text>
          </View>
          <Text style={styles.listItem}>
            3. The Loan-To-Value (LTV) ratio may affect eligibility/fees.
            Appraised value (by independent appraiser, subject to underwriting)
            may be used to determine max loan amount and can be ≥ Purchase
            Price/market price.
          </Text>
        </View>

        <Text style={styles.listItem}>
          6. <Text style={styles.bold}>Mortgage Contingency:</Text> This sale is{' '}
          <Text style={styles.DangerText}>NOT contingent</Text> on mortgage
          financing, although Buyer may obtain financing and/or include an
          appraisal contingency. Buyer and Seller understand this waiver does
          not restrict Buyer’s right to obtain financing for the Property.
        </Text>
      </View>
    </View>
  );
};

export default CashOffer;
